export const TaskCardSkeleton = () => {
  return (
    <div className="bg-gradient-to-br from-white to-blue-200 p-6 shadow-lg w-full max-w-sm rounded-2xl font-sans mx-auto animate-pulse">
      
      {/* Avatar */}
      <div className="flex flex-col items-center text-center space-y-3">
        <div className="w-24 h-24 rounded-full bg-gray-300 shadow-lg ring-4" />

        <div className="w-32 h-4 bg-gray-300 rounded-md" />
        <div className="w-20 h-3 bg-gray-200 rounded-md" />
      </div>

      {/* Status Tag */}
      <div className="flex justify-center mt-4">
        <div className="w-24 h-6 bg-gray-300 rounded-full" />
      </div>

      {/* Task List */}
      <div className="w-full bg-white p-3 rounded-xl max-h-28 mt-4 overflow-hidden shadow-inner space-y-3">
        {[1].map((i) => (
          <div
            key={i}
            className="p-3 bg-blue-50 rounded-lg shadow-sm border border-blue-100 space-y-2"
          >
            {/* Task Title */}
            <div className="w-40 h-3 bg-gray-300 rounded" />

            {/* Task Grid */}
            <div className="grid grid-cols-3 gap-2">
              <div className="space-y-1">
                <div className="w-10 h-2 bg-gray-200 rounded" />
                <div className="w-12 h-3 bg-gray-300 rounded" />
              </div>
              <div className="space-y-1">
                <div className="w-10 h-2 bg-gray-200 rounded" />
                <div className="w-12 h-3 bg-gray-300 rounded" />
              </div>
              <div className="space-y-1">
                <div className="w-10 h-2 bg-gray-200 rounded" />
                <div className="w-12 h-3 bg-gray-300 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};
